import { FundriseRouteConfig } from 'vue-router';

/* eslint-disable @typescript-eslint/explicit-function-return-type */
const educationRoutes: FundriseRouteConfig[] = [
	{
		path: `/education`,
		name: 'blog-landing',
		meta: { minTokenScopeRequired: 'UNAUTHENTICATED' },
		component: () => import(/* webpackChunkName: "blog-landing" */ '@views/blog/landing.vue')
	},
	{
		path: `/education/glossary`,
		name: 'blog-glossary',
		meta: { minTokenScopeRequired: 'UNAUTHENTICATED' },
		component: () => import(/* webpackChunkName: "blog-glossary" */ '@views/blog/glossary.vue')
	},
	{
		path: `/education/glossary/:termUrlSlug`,
		name: 'blog-glossary-term',
		meta: { minTokenScopeRequired: 'UNAUTHENTICATED' },
		component: () => import(/* webpackChunkName: "blog-glossary-term" */ '@views/blog/glossary-term.vue')
	},
	{
		path: `/education/:blogPostUrlSlug`,
		name: 'blog-post',
		meta: { minTokenScopeRequired: 'UNAUTHENTICATED' },
		component: () => import(/* webpackChunkName: "blog-article" */ '@views/blog/article.vue')
	},
	{
		path: `/education/category/:categoryUrlSlug`,
		name: 'blog-category',
		meta: { minTokenScopeRequired: 'UNAUTHENTICATED' },
		component: () => import(/* webpackChunkName: "blog-category" */ '@views/blog/category.vue')
	},
	{
		path: `/webview/education/:blogPostUrlSlug`,
		name: 'webview-blog-post',
		meta: { minTokenScopeRequired: 'UNAUTHENTICATED' },
		component: () =>
			import(/* webpackChunkName: "blog-article-webview" */ '@views/webview/article-body-content.vue')
	}
];

export default educationRoutes;
